export default "__VITE_ASSET__10bdd839__"